import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import ExpeditorRejectedIcon from "../../../../shared/icons/ExpeditorRejectedIcon";
import style from "./ExpeditorRejectedOrderCard.module.scss";

const ExpeditorRejectedOrderCard = ({ history = [], updatedAt, onFindNewOrders }) => {
  const { t } = useTranslation();
  const rejectedStatus = [...(Array.isArray(history) ? history : [])]
    .reverse()
    .find((item) => ["expeditorrejected", "rejected"].includes(String(item?.statusCode || "").toLowerCase()));
  const rejectedAt = rejectedStatus?.createdAt || updatedAt;
  const date = rejectedAt ? moment(rejectedAt) : null;

  return (
    <section className={style.card}>
      <div className={style.icon} aria-hidden="true">
        <ExpeditorRejectedIcon />
      </div>
      <div className={style.text_group}>
        <h3 className={style.title}>{t("orderInfoExpeditor.actions.orderRejectedTitle")}</h3>
        {date?.isValid() ? (
          <p className={style.date}>
            {t("orderInfoExpeditor.actions.orderRejectedAt", { date: date.format("DD.MM.YYYY, HH:mm") })}
          </p>
        ) : null}
      </div>
      <div className={style.action}>
        <CustomButton
          type="button"
          text={t("orderInfoExpeditor.bid.findNewOrders")}
          isNavy
          isFall
          onClick={onFindNewOrders}
        />
      </div>
    </section>
  );
};

export default ExpeditorRejectedOrderCard;
